import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import { Button, Checkbox, CheckboxGroup, Dialog, Form, Input, Option, OptionGroup, Pagination, Radio, Select, Table, TableColumn, Tooltip, Upload, loading } from 'element-ui'

Vue.use(Button)
Vue.use(Select)
Vue.use(Form)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Input)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Upload)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Tooltip)
Vue.use(loading)
